export type BrandVariant = "classic" | "premium";

export type BrandAssets = {
  variant: BrandVariant;
  headerLogoSrc: string;
  headerLogoAlt: string;
  faviconHref: string;
  glowGradient: string;
};

export const CLASSIC_BRAND: BrandAssets = {
  variant: "classic",
  headerLogoSrc: "/logos/primary/mixmind-icon-blue.svg",
  headerLogoAlt: "Logo MixMind (version classique)",
  faviconHref: "/logos/primary/mixmind-icon-blue.svg",
  glowGradient: "linear-gradient(135deg, #4C6FFF 0%, #7A53FF 100%)",
};

export const PREMIUM_BRAND: BrandAssets = {
  variant: "premium",
  headerLogoSrc: "/logos/primary/mixmind-icon-orange.svg",
  headerLogoAlt: "Logo MixMind (version premium)",
  faviconHref: "/logos/primary/mixmind-icon-orange.svg",
  glowGradient: "linear-gradient(135deg, #FF6B6B 0%, #FFC75F 100%)",
};

export function getBrandAssets(
  isPremium: boolean | undefined | null
): BrandAssets {
  return isPremium ? PREMIUM_BRAND : CLASSIC_BRAND;
}
